import { SemanticScore, getSemanticScore } from "./scoreUtils";
import { isWithinRange } from "./utils";
import COACHING_BENCHMARKS from "../coaching/coachingBenchmarks";

export const isWpmWithinRecommendedRange = (wpm: number) =>
  isWithinRange(
    wpm,
    [COACHING_BENCHMARKS.wpm.min, COACHING_BENCHMARKS.wpm.max],
    { inclusiveEnd: true }
  );

export const getWpmSemanticScore = (rate: number | null): SemanticScore =>
  rate == null
    ? "unknown"
    : isWpmWithinRecommendedRange(rate)
      ? "positive"
      : "negative";

export const getFillerWordsSemanticScore = (
  rate: number | null
): SemanticScore =>
  getSemanticScore(
    rate ? Math.round(rate) : rate,
    COACHING_BENCHMARKS.fillerWordsThresholds,
    { inverted: true, inclusive: false }
  );

export const getNonInclusiveTermsSemanticScore = (
  count: number | null
): SemanticScore =>
  getSemanticScore(count, COACHING_BENCHMARKS.nonInclusiveTermThresholds, {
    inverted: true,
    inclusive: false,
  });

export const getInterruptionsSemanticScore = (
  count: number | null
): SemanticScore =>
  getSemanticScore(count, COACHING_BENCHMARKS.interruptionThresholds, {
    inverted: true,
    inclusive: false,
  });

export const getQuestionsAskedSemanticScore = (
  count: number | null
): SemanticScore => ((count ?? 0) >= 1 ? "positive" : "unknown");
